import React from 'react'

const BlockLineShape = (canvas, fabric) => {
    let pointer
    let isDrawingLine = false
    let pointerPoints
    let polygon
    let line1
    let line2

    canvas.on('mouse:down', (o) => {
        if (!canvas.isDrawingBlockLineMode) return

        if (canvas?.getActiveObject()) return

        isDrawingLine = true
        pointer = []
        pointerPoints = canvas.getPointer(o.e)
        pointer[0] = { x: pointerPoints.x, y: pointerPoints.y }

        polygon = new fabric.Polyline(pointer, {
            strokeWidth: 2,
            stroke: window.globalColor,
            fill: false,
            scaleX: 1,
            scaleY: 1,
            edit: false,
            hasBorders: false,
            objectCaching: false,
            transparentCorners: false,
            hasControls: false
        })
        line1 = new fabric.Line(
            [
                pointerPoints.x,
                pointerPoints.y - 50,
                pointerPoints.x,
                pointerPoints.y + 50
            ],
            {
                stroke: window.globalColor,
                strokeWidth: 2,
                hasControls: false,
                hasBorders: false
            }
        )
        canvas.add(line1)
        line1.setCoords()
        canvas.add(polygon)
    })

    canvas.on('mouse:move', (o) => {
        if (!isDrawingLine) return
        pointerPoints = canvas.getPointer(o.e)
        const dims = polygon._calcDimensions()
        pointer[1] = { x: pointerPoints.x, y: pointerPoints.y }
        polygon.set({
            width: dims.width,
            height: dims.height,
            left: dims.left,
            top: dims.top,
            pathOffset: {
                x: dims.width / 2 + dims.left,
                y: dims.height / 2 + dims.top
            },
            dirty: true
        })

        canvas.requestRenderAll()
        canvas.calcOffset()
        // canvas.setActiveObject(polygon);
    })

    canvas.on('mouse:up', () => {
        if (!isDrawingLine) return
        line2 = new fabric.Line(
            [
                pointerPoints.x,
                pointerPoints.y - 50,
                pointerPoints.x,
                pointerPoints.y + 50
            ],
            {
                stroke: window.globalColor,
                strokeWidth: 2,
                hasControls: false,
                hasBorders: false
            }
        )
        canvas.add(line2)
        line2.setCoords()
        polygon.setCoords()
        isDrawingLine = false
        canvas.fire('object:modified')
    })
}

export default BlockLineShape
